import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import Header from './Header';
import Footer from './Footer';
// import blogdetailbanner from '../images/blog-detail-banner.jpg';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

const HeartOfTheStory = () => {
  const [articles, setArticles] = useState([]);

  const slugify = (title) =>
    title.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');

  useEffect(() => {
    const fetchArticles = async () => {
      try {
        const response = await axios.get('https://petcrew.in/app-admin/api/blog.php?type=all&page=1');
        if (Array.isArray(response.data.Data)) {
          setArticles(response.data.Data);
        } else {
          console.error('API response is not an array:', response.data);
        }
      } catch (error) {
        console.error('Error fetching articles:', error);
      }
    };
    fetchArticles();
  }, []);

  return (
    <>
 <Helmet>
 <title>PetCrew Story | How We Started Caring for India’s Pets</title>
  <meta name="description" content="Discover the journey of PetCrew — from a passion for pets to a leading provider of trusted pet care services across India." />
  <meta name="keywords" content="about PetCrew, pet startup story, pet care mission, pet company India, PetCrew journey" />

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Blog",
            "name": "PetCrew Blog - Heart of the Story",
            "url": "https://petcrew.in/blog",
            "description": "Explore pet health and wellness tips, stories, and expert advice from PetCrew's blog articles.",
            "publisher": {
              "@type": "Organization",
              "name": "PetCrew",
              "logo": {
                "@type": "ImageObject",
                "url": "https://petcrew.in/logo.png", // update with actual logo URL
              },
            },
          })}
        </script>
      </Helmet>

      <Header />
      <div className="container my-4">
        <div className="row mb-4">
          <div className="col-12">
            <div className="card blog-detail-card text-white">
              {/* <img
                src={blogdetailbanner}
                className="card-img"
                alt="Featured Article"
              /> */}
            </div>
          </div>
        </div>

        <div className="row">
          {articles.length === 0 ? (
            <p>Loading articles...</p>
          ) : (
            articles.map((article) => {
              const slug = slugify(article.title);
              return (
                <div className="col-md-4 col-sm-6 mb-4" key={article.id}>
                  <Link
                    to={`/blog-detail/${article.id}/${slug}`}
                    className="text-decoration-none text-dark"
                  >
                    <div className="card h-100 shadow-sm">
                      <img
                        src={article.image_link}
                        className="card-img-top"
                        alt={article.title}
                      />
                      <div className="card-body">
                        <span className="card-title fw-bold">{article.title}</span>
                        <p className="card-text">{article.desc}</p>
                        <div className="author-detail text-muted small d-flex justify-content-between">
                          <span>PetCrew Team</span>
                          <span>{article.posted_on}</span>
                        </div>
                      </div>
                    </div>
                  </Link>
                </div>
              );
            })
          )}
        </div>
      </div>
      <Footer />
    </>
  );
};

export default HeartOfTheStory;
